import React from 'react'
import {
    Box,
    Button,
    Grid,
    Typography,
    makeStyles,
    Theme,
} from '@material-ui/core'
import OpenInNewIcon from '@material-ui/icons/OpenInNew'
import { Link } from 'react-router-dom'

import { ApartmentLeaseTerm } from '../../../models/Company/types'
import {
    PROPERTY_DETAILS_TAB,
    propertyDetailsPath,
} from '../../../main/containers/settings/PropertyDetails/propertyDetailsTabUtils'
import { formatSeasonDate } from '../utils/seasonDates'

const useStyles = makeStyles((theme: Theme) => ({
    dates: {
        marginBottom: theme.spacing(1),
    },
    statTile: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        padding: theme.spacing(0.75, 1),
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.spacing(1),
        backgroundColor: theme.palette.background.paper,
    },
    statLabel: {
        fontSize: '0.625rem',
        fontWeight: 600,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        color: theme.palette.text.secondary,
    },
    statValue: {
        marginTop: theme.spacing(0.25),
        fontSize: '1rem',
        fontWeight: 600,
        color: theme.palette.text.primary,
    },
    prompt: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    promptText: {
        fontSize: '0.875rem',
        flex: 1,
    },
    detailsButton: {
        flexShrink: 0,
        textTransform: 'none',
    },
}))

const DATE_FIELDS: { key: keyof ApartmentLeaseTerm; label: string }[] = [
    { key: 'start_date', label: 'Start' },
    { key: 'end_date', label: 'End' },
    { key: 'move_in_date', label: 'Move-in' },
    { key: 'move_out_date', label: 'Move-out' },
]

export const LeaseTermApplyFields: React.FC<{
    term: ApartmentLeaseTerm | null
}> = ({ term }) => {
    const classes = useStyles()
    if (!term) return null
    return (
        <Grid container spacing={1} className={classes.dates}>
            {DATE_FIELDS.map((field) => (
                <Grid item xs={6} key={field.key}>
                    <Box className={classes.statTile}>
                        <Typography className={classes.statLabel}>
                            {field.label}
                        </Typography>
                        <Typography className={classes.statValue}>
                            {formatSeasonDate(String(term[field.key] ?? ''))}
                        </Typography>
                    </Box>
                </Grid>
            ))}
        </Grid>
    )
}

export const LeaseTermPropertyDetailsPrompt: React.FC = () => {
    const classes = useStyles()
    return (
        <Box className={classes.prompt}>
            <Typography className={classes.promptText}>
                Do you need to add a lease term or edit your lease terms?
            </Typography>
            <Button
                className={classes.detailsButton}
                variant="outlined"
                color="primary"
                size="small"
                component={Link}
                to={propertyDetailsPath(PROPERTY_DETAILS_TAB.leaseTerms)}
                startIcon={<OpenInNewIcon />}
            >
                Property Details
            </Button>
        </Box>
    )
}
